<script lang="ts" setup>
import IonCheckmarkSharp from '#components/icons/IonCheckmarkSharp.vue'
import { useStore, useVModel } from '@nanostores/vue'
import { onMounted, ref, watch } from 'vue'
import {
  $reviewConfirmationAgreed,
  $reviewConfirmationMessage,
  $selectedVariantId
} from './product-customization-board.store'

const selectedVariantId = useStore($selectedVariantId)
const confirmationMessage = useStore($reviewConfirmationMessage)
const confirmationAgreed = useStore($reviewConfirmationAgreed)

const confirmationAgreedModel = useVModel($reviewConfirmationAgreed)

const root = ref<HTMLElement | null>(null)

const toggleAddToCartBtn = () => {
  const productFormEl = root.value?.closest('form[action*="/cart/add"]')
  const addToCartButtonEl = productFormEl?.querySelector('button[name="add"]')

  if (confirmationAgreed.value) {
    addToCartButtonEl?.removeAttribute('disabled')
  } else {
    addToCartButtonEl?.setAttribute('disabled', '')
  }
}

watch([confirmationAgreed, selectedVariantId], () => {
  toggleAddToCartBtn()
})

onMounted(() => {
  toggleAddToCartBtn()
})
</script>

<template>
  <Teleport to="#customizationReviewConfirmation">
    <label
      ref="root"
      for="reviewConfirmationInput"
      class="tw-mb-4 tw-flex tw-cursor-pointer tw-items-start tw-gap-3 tw-bg-neutral-100 tw-p-3 tw-text-sm tw-text-gray-600"
    >
      <span
        tabindex="0"
        class="focus:tw-border-w-2 tw-mt-1 tw-flex tw-aspect-square tw-h-4 tw-items-center tw-justify-center tw-border tw-border-solid tw-border-black tw-transition-[border] tw-duration-150 hover:tw-border-2"
      >
        <IonCheckmarkSharp v-if="confirmationAgreed" class="tw-h-4 tw-w-4" />
      </span>
      <span class="tw-block">{{ confirmationMessage }}</span>
      <input
        id="reviewConfirmationInput"
        v-model="confirmationAgreedModel"
        tabindex="-1"
        type="checkbox"
        class="tw-sr-only"
      />
    </label>
  </Teleport>
</template>
